export default "__VITE_ASSET__BOUMsAup__"